import React from "react";
// Framer Motion
import {motion} from 'framer-motion';
// Animation
import { fadeIn, titleAnim, fade } from "../animation";
// Styled Components
//import { About, Description, Hide } from "../styles";
import styled from 'styled-components';
// Image
import splash from '../img/splash.svg';

const AboutSection = () => {
    return(
        <Intro>
            <IntroText>
                <motion.h2 variants={fadeIn}>TouchPoint Web Design</motion.h2>
                <motion.h3 variants={fadeIn}>Build your website<motion.span>TODAY</motion.span></motion.h3>
                <motion.p variants={fadeIn}>Creating and maintaining professional websites built with a modern look and feel for busy individuals or small businesses</motion.p>
                <IntroSocial variants={fadeIn}>
                    <a href="/contact"><button>Inquire</button></a>
                </IntroSocial>
            </IntroText>
            <IntroImg>
                <motion.svg
                    width="799"
                    height="690"
                    viewBox="0 0 799 690"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    variants={fadeIn}
                >
                    <motion.g id="undraw_dev_productivity_umsq (1) 1" clip-path="url(#clip0)">
                    <motion.path
                        id="Vector"
                        d="M516.92 624.636C516.92 624.636 512.16 626.266 504.42 628.576C487.31 633.706 455.65 642.216 428.82 643.916C405.72 645.396 386.2 641.836 382.63 626.766C381.1 620.286 383.27 614.956 388 610.576C402.12 597.486 439 592.796 468.25 591.186C476.51 590.736 484.15 590.526 490.51 590.446C501.31 590.306 508.39 590.526 508.39 590.526L508.56 591.186L516.92 624.636Z"
                        fill="#A0616A"
                    />
                    <motion.path
                        id="Vector_2"
                        d="M436.99 672.586C418.61 695.346 342.73 647.666 316.19 629.886C310.41 626.016 306.97 623.566 306.97 623.566L331.25 591.186L338.94 580.936C338.94 580.936 345.82 584.586 355.99 590.526C356.36 590.746 356.73 590.966 357.11 591.186C365.88 596.336 376.89 603.066 388 610.576C403.33 620.946 418.83 632.776 428.82 643.916C438.59 654.806 443.08 665.036 436.99 672.586Z"
                        fill="#A0616A"
                    />
                    <motion.g id="me">
                        <motion.path
                        id="Vector_3"
                        d="M434.672 191.952C475.283 191.607 507.926 158.406 507.582 117.795C507.237 77.1832 474.036 44.5403 433.425 44.8847C392.813 45.2291 360.17 78.4303 360.515 119.042C360.859 159.653 394.06 192.296 434.672 191.952Z"
                        fill="#A0616A"
                        />
                        <motion.path
                        id="Vector_4"
                        d="M379.477 155.65C379.477 155.65 394.216 259.972 373.002 271.875C351.787 283.779 499.929 283.588 499.929 283.588C499.929 283.588 466.124 193.284 480.809 165.449L379.477 155.65Z"
                        fill="#A0616A"
                        />
                        <motion.path
                        id="Vector_5"
                        d="M608.101 283.199L596.257 339.402L571.214 458.308L570.49 464.815L562.138 540.138L556.582 590.177L552.857 623.79C528.584 636.526 510.988 645.326 510.988 645.326C510.988 645.326 509.404 637.719 506.871 627.99C489.805 633.265 458.218 642.043 431.404 643.97C441.266 654.777 445.842 664.969 439.817 672.57C421.63 695.485 345.349 648.45 318.659 630.896C318.077 635.158 317.879 639.464 318.068 643.762L297.626 628.314L299.331 592.359L302.206 531.522L305.819 455.229C304.448 451.975 303.294 448.634 302.364 445.228C295.956 423.161 288.032 379.057 281.928 342.067C277.016 312.298 273.302 287.138 272.517 281.785C272.411 281.086 272.358 280.726 272.358 280.726L384.363 230.094C392.509 248.556 429.865 253.809 429.865 253.809C460.756 251.417 484.847 234.913 484.847 234.913L608.101 283.199Z"
                        fill="white"
                        />
                        <motion.path
                        id="Vector_6"
                        d="M372.285 49.3811L358.49 43.9934C358.49 43.9934 386.969 12.1 426.99 14.513L415.635 2.22366C415.635 2.22366 443.04 -9.01799 468.283 19.6674C481.553 34.7467 496.908 52.4737 506.557 72.5077L521.281 72.3829L515.251 85.9663L536.874 99.3152L514.777 97.0719C516.155 104.471 516.421 112.034 515.566 119.511C514.683 126.991 510.928 133.835 505.094 138.598V138.598C505.094 138.598 487.743 103.449 487.696 97.9443L487.813 111.705C487.813 111.705 473.959 99.4371 473.889 91.1807L466.471 100.877L462.593 85.7717L416.475 101.301L423.87 88.8526L395.157 93.2246L406.278 77.9923C406.278 77.9923 373.932 96.1568 372.811 111.304C371.689 126.452 362.299 140.875 362.299 140.875C362.299 140.875 336.213 70.3294 372.285 49.3811Z"
                        fill="#2F2E41"
                        />
                        <motion.path
                        id="Vector_7"
                        d="M690.215 540.422C682.794 548.605 664.338 560.992 641.951 574.422C633.623 579.413 624.757 584.559 615.71 589.676C594.122 601.889 571.514 614.001 552.857 623.79C528.584 636.526 510.988 645.326 510.988 645.326C510.988 645.326 509.403 637.719 506.871 627.99C503.48 614.968 498.397 598.141 493.184 590.715C493.002 590.456 492.82 590.218 492.638 589.979C491.121 588.022 489.601 586.885 488.112 586.897L562.138 540.138L594.127 519.926L570.489 464.814L540.842 395.683L557.908 339.727L575.062 283.479L608.101 283.199C608.101 283.199 619.243 306.985 633.514 340.166C635.647 345.128 637.851 350.299 640.096 355.64C669.469 425.394 706.176 522.836 690.215 540.422Z"
                        fill="#EEEEEE"
                        />
                        <motion.path
                        id="Vector_8"
                        d="M358.123 591.2C355.41 591.212 352.702 591.456 350.029 591.928C327.074 596.073 320.47 616.94 318.659 630.896C318.077 635.158 317.879 639.464 318.068 643.761L297.626 628.314L290.178 622.687C272.316 616.628 256.353 605.733 242.483 592.84C230.449 581.456 219.634 568.849 210.213 555.223C200.831 541.793 192.448 527.692 185.134 513.034C183.094 508.943 181.977 504.454 181.864 499.884C181.751 495.314 182.644 490.775 184.48 486.588L209.154 430.327L245.218 348.098C245.471 346.146 245.752 344.237 246.059 342.371C252.995 300.511 272.367 281.786 272.367 281.786L287.286 281.659L297.778 341.932L310.813 416.815L302.364 445.227L282.839 510.845L302.205 531.522L358.123 591.2Z"
                        fill="#EEEEEE"
                        />
                    </motion.g>
                    <motion.path
                        id="shirt-thing"
                        d="M372.877 415.806L385.631 430.686C390.37 429.783 395.319 428.721 400.416 427.529L396.752 415.806L405.71 426.256C459.707 412.975 526.637 387.155 526.637 387.155C526.637 387.155 454.379 392.453 400.428 380.666C376.558 375.451 351.998 387.284 342.202 409.668C336.508 422.679 337.403 433.951 357.596 433.951C364.419 433.835 371.223 433.195 377.949 432.037L372.877 415.806Z"
                        fill="#d36738"
                    />
                    <motion.path
                        id="Vector_10"
                        d="M663.65 660.386V666.456C663.654 668.122 663.345 669.774 662.74 671.326C662.472 672.018 662.147 672.687 661.77 673.326C660.578 675.326 658.887 676.983 656.862 678.133C654.838 679.283 652.549 679.887 650.22 679.886H203.67C201.342 679.887 199.053 679.283 197.028 678.133C195.003 676.983 193.312 675.326 192.12 673.326C191.743 672.687 191.419 672.018 191.15 671.326C190.546 669.774 190.237 668.122 190.24 666.456V660.386C190.24 658.622 190.587 656.876 191.262 655.246C191.936 653.616 192.926 652.136 194.173 650.888C195.42 649.641 196.901 648.652 198.53 647.977C200.16 647.302 201.906 646.955 203.67 646.956H229.41V644.126C229.41 644.052 229.425 643.979 229.453 643.911C229.481 643.843 229.522 643.782 229.574 643.73C229.626 643.678 229.688 643.636 229.756 643.608C229.824 643.58 229.897 643.566 229.97 643.566H243.4C243.474 643.566 243.547 643.58 243.615 643.608C243.683 643.636 243.745 643.678 243.797 643.73C243.849 643.782 243.89 643.843 243.918 643.911C243.946 643.979 243.96 644.052 243.96 644.126V646.956H252.35V644.126C252.35 644.052 252.365 643.979 252.393 643.911C252.421 643.843 252.462 643.782 252.514 643.73C252.566 643.678 252.628 643.636 252.696 643.608C252.764 643.58 252.837 643.566 252.91 643.566H266.34C266.414 643.566 266.487 643.58 266.555 643.608C266.623 643.636 266.684 643.678 266.736 643.73C266.789 643.782 266.83 643.843 266.858 643.911C266.886 643.979 266.9 644.052 266.9 644.126V646.956H275.3V644.126C275.3 644.052 275.315 643.979 275.343 643.911C275.371 643.843 275.412 643.782 275.464 643.73C275.516 643.678 275.578 643.636 275.646 643.608C275.714 643.58 275.787 643.566 275.86 643.566H289.29C289.364 643.566 289.437 643.58 289.505 643.608C289.573 643.636 289.634 643.678 289.686 643.73C289.739 643.782 289.78 643.843 289.808 643.911C289.836 643.979 289.85 644.052 289.85 644.126V646.956H298.24V644.126C298.24 644.052 298.255 643.979 298.283 643.911C298.311 643.843 298.352 643.782 298.404 643.73C298.456 643.678 298.518 643.636 298.586 643.608C298.654 643.58 298.727 643.566 298.8 643.566H312.23C312.304 643.566 312.377 643.58 312.445 643.608C312.513 643.636 312.574 643.678 312.626 643.73C312.678 643.782 312.72 643.843 312.748 643.911C312.776 643.979 312.79 644.052 312.79 644.126V646.956H321.18V644.126C321.18 644.052 321.194 643.979 321.223 643.911C321.251 643.843 321.292 643.782 321.344 643.73C321.396 643.678 321.458 643.636 321.526 643.608C321.594 643.58 321.667 643.566 321.74 643.566H335.17C335.244 643.566 335.317 643.58 335.385 643.608C335.453 643.636 335.514 643.678 335.566 643.73C335.618 643.782 335.66 643.843 335.688 643.911C335.716 643.979 335.73 644.052 335.73 644.126V646.956H344.13V644.126C344.13 644.052 344.145 643.979 344.173 643.911C344.201 643.843 344.242 643.782 344.294 643.73C344.346 643.678 344.408 643.636 344.476 643.608C344.544 643.58 344.617 643.566 344.69 643.566H358.12C358.194 643.566 358.267 643.58 358.335 643.608C358.403 643.636 358.464 643.678 358.516 643.73C358.569 643.782 358.61 643.843 358.638 643.911C358.666 643.979 358.68 644.052 358.68 644.126V646.956H367.07V644.126C367.07 644.052 367.085 643.979 367.113 643.911C367.141 643.843 367.182 643.782 367.234 643.73C367.286 643.678 367.348 643.636 367.416 643.608C367.484 643.58 367.557 643.566 367.63 643.566H472.83C472.904 643.566 472.977 643.58 473.045 643.608C473.113 643.636 473.174 643.678 473.227 643.73C473.279 643.782 473.32 643.843 473.348 643.911C473.376 643.979 473.39 644.052 473.39 644.126V646.956H481.79V644.126C481.79 644.052 481.804 643.979 481.833 643.911C481.861 643.843 481.902 643.782 481.954 643.73C482.006 643.678 482.068 643.636 482.136 643.608C482.204 643.58 482.277 643.566 482.35 643.566H495.78C495.928 643.567 496.07 643.627 496.175 643.732C496.279 643.836 496.339 643.978 496.34 644.126V646.956H504.73V644.126C504.73 644.052 504.745 643.979 504.773 643.911C504.801 643.843 504.842 643.782 504.894 643.73C504.946 643.678 505.008 643.636 505.076 643.608C505.144 643.58 505.217 643.566 505.29 643.566H518.72C518.794 643.566 518.867 643.58 518.935 643.608C519.003 643.636 519.065 643.678 519.117 643.73C519.169 643.782 519.21 643.843 519.238 643.911C519.266 643.979 519.28 644.052 519.28 644.126V646.956H527.67V644.126C527.67 644.052 527.685 643.979 527.713 643.911C527.741 643.843 527.782 643.782 527.834 643.73C527.886 643.678 527.948 643.636 528.016 643.608C528.084 643.58 528.157 643.566 528.23 643.566H541.66C541.734 643.566 541.807 643.58 541.875 643.608C541.943 643.636 542.005 643.678 542.057 643.73C542.109 643.782 542.15 643.843 542.178 643.911C542.206 643.979 542.22 644.052 542.22 644.126V646.956H550.62V644.126C550.62 644.052 550.635 643.979 550.663 643.911C550.691 643.843 550.732 643.782 550.784 643.73C550.836 643.678 550.898 643.636 550.966 643.608C551.034 643.58 551.107 643.566 551.18 643.566H564.61C564.757 643.568 564.898 643.628 565.001 643.733C565.104 643.837 565.161 643.979 565.16 644.126V646.956H573.56V644.126C573.56 644.052 573.575 643.979 573.603 643.911C573.631 643.843 573.672 643.782 573.724 643.73C573.776 643.678 573.838 643.636 573.906 643.608C573.974 643.58 574.047 643.566 574.12 643.566H587.55C587.624 643.566 587.697 643.58 587.765 643.608C587.833 643.636 587.895 643.678 587.947 643.73C587.999 643.782 588.04 643.843 588.068 643.911C588.096 643.979 588.11 644.052 588.11 644.126V646.956H596.5V644.126C596.5 644.052 596.515 643.979 596.543 643.911C596.571 643.843 596.612 643.782 596.664 643.73C596.716 643.678 596.778 643.636 596.846 643.608C596.914 643.58 596.987 643.566 597.06 643.566H610.49C610.564 643.566 610.637 643.58 610.705 643.608C610.773 643.636 610.835 643.678 610.887 643.73C610.939 643.782 610.98 643.843 611.008 643.911C611.036 643.979 611.05 644.052 611.05 644.126V646.956H650.22C651.984 646.955 653.731 647.302 655.36 647.977C656.99 648.652 658.471 649.641 659.718 650.888C660.965 652.136 661.954 653.616 662.629 655.246C663.304 656.876 663.651 658.622 663.65 660.386Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_11"
                        d="M793.5 671.326H60.5V673.326H793.5V671.326Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_12"
                        d="M627.694 404.757H461.251V401.326H385.78V404.757H218.651C215.665 404.757 212.801 405.943 210.69 408.054C208.578 410.166 207.392 413.029 207.392 416.015V643.927C207.392 646.913 208.578 649.776 210.69 651.888C212.801 653.999 215.665 655.185 218.651 655.185H627.694C630.68 655.185 633.544 653.999 635.655 651.888C637.767 649.776 638.953 646.913 638.953 643.927V416.015C638.953 414.537 638.662 413.073 638.096 411.707C637.53 410.341 636.701 409.1 635.655 408.054C634.61 407.009 633.369 406.18 632.003 405.614C630.637 405.048 629.173 404.757 627.694 404.757Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_13"
                        d="M423.5 509.326C437.307 509.326 448.5 498.133 448.5 484.326C448.5 470.519 437.307 459.326 423.5 459.326C409.693 459.326 398.5 470.519 398.5 484.326C398.5 498.133 409.693 509.326 423.5 509.326Z"
                        stroke="#D0CDE1"
                        stroke-width="2"
                        stroke-miterlimit="10"
                    />
                    <motion.path
                        id="Vector_14"
                        d="M415.5 518.326C429.307 518.326 440.5 507.133 440.5 493.326C440.5 479.519 429.307 468.326 415.5 468.326C401.693 468.326 390.5 479.519 390.5 493.326C390.5 507.133 401.693 518.326 415.5 518.326Z"
                        fill="#D0CDE1"
                    />
                    <motion.path
                        id="Vector_15"
                        d="M108.446 661.223H80.4463V689.223H108.446V661.223Z"
                        fill="#D0CDE1"
                    />
                    <motion.path
                        id="Vector_16"
                        d="M91.4502 639.223V673.223H125.45V639.223H91.4502ZM123.97 671.743H92.9202V640.703H123.97V671.743Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_17"
                        d="M756.446 661.223H728.446V689.223H756.446V661.223Z"
                        fill="#D0CDE1"
                    />
                    <motion.path
                        id="Vector_18"
                        d="M739.45 639.223V673.223H773.45V639.223H739.45ZM771.97 671.743H740.92V640.703H771.97V671.743Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_19"
                        d="M94.5802 230.113C138.399 230.113 173.921 194.592 173.921 150.773C173.921 106.955 138.399 71.4326 94.5802 71.4326C50.7617 71.4326 15.2397 106.955 15.2397 150.773C15.2397 194.592 50.7617 230.113 94.5802 230.113Z"
                        fill="#d36738"
                    />
                    <motion.path
                        id="Vector_20"
                        d="M122.229 56.4899C115.045 55.5763 107.774 55.5763 100.59 56.4899C84.586 58.5913 69.5203 65.2398 57.181 75.6465C44.8417 86.0532 35.7467 99.7813 30.9754 115.202C28.8053 122.229 27.5764 129.514 27.3208 136.864C27.2848 137.886 27.2607 138.92 27.2607 139.954C27.283 162.264 36.1559 183.655 51.932 199.431C67.7082 215.207 89.0989 224.08 111.41 224.103C113.201 224.103 114.992 224.042 116.759 223.934C120.907 223.674 125.03 223.103 129.093 222.227C148.495 218.055 165.798 207.161 177.947 191.468C190.095 175.776 196.308 156.295 195.487 136.467C194.665 116.638 186.863 97.738 173.459 83.1039C160.054 68.4698 141.909 59.0435 122.229 56.4899H122.229ZM137.748 217.347H137.736C130.959 219.659 123.905 221.062 116.759 221.518C114.992 221.638 113.201 221.698 111.41 221.698C89.7377 221.672 68.961 213.051 53.6367 197.727C38.3123 182.402 29.6914 161.626 29.6649 139.954C29.6649 138.92 29.689 137.886 29.725 136.864C30.5514 115.744 39.5156 95.7617 54.7411 81.1008C69.9666 66.44 90.273 58.237 111.41 58.2089C130.776 58.21 149.513 65.0865 164.283 77.6131C179.052 90.1398 188.895 107.503 192.057 126.61C195.219 145.716 191.496 165.325 181.55 181.942C171.604 198.559 156.081 211.106 137.748 217.347H137.748Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_21"
                        d="M112.612 63.0176H110.208V79.8474H112.612V63.0176Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_22"
                        d="M57.8578 84.7018L56.1577 86.4019L68.0582 98.3023L69.7582 96.6022L57.8578 84.7018Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_23"
                        d="M34.4736 138.751V141.156H51.3034V138.751H34.4736Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_24"
                        d="M56.1578 193.506L57.8579 195.206L69.7584 183.306L68.0583 181.606L56.1578 193.506Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_25"
                        d="M153.062 96.6022L154.762 98.3022L166.662 86.4018L164.962 84.7017L153.062 96.6022Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_26"
                        d="M171.516 138.751V141.156H188.346V138.751H171.516Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_27"
                        d="M154.762 181.605L153.062 183.305L164.962 195.206L166.662 193.506L154.762 181.605Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_28"
                        d="M112.612 200.06H110.208V216.89H112.612V200.06Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_29"
                        d="M115.016 135.145C113.976 134.365 112.711 133.943 111.41 133.943C110.11 133.943 108.844 134.365 107.804 135.145C107.091 135.686 106.505 136.375 106.085 137.165C105.552 138.181 105.322 139.329 105.421 140.473C105.52 141.616 105.944 142.707 106.644 143.617C107.343 144.527 108.288 145.218 109.368 145.608C110.447 145.997 111.616 146.07 112.735 145.817C113.855 145.564 114.878 144.996 115.685 144.179C116.492 143.363 117.048 142.333 117.288 141.21C117.528 140.088 117.441 138.92 117.039 137.846C116.636 136.771 115.935 135.834 115.017 135.145H115.016ZM111.41 143.56C110.454 143.557 109.539 143.176 108.863 142.501C108.187 141.825 107.807 140.909 107.804 139.954C107.808 139.224 108.03 138.513 108.441 137.91C108.793 137.4 109.271 136.989 109.828 136.718C110.386 136.446 111.004 136.323 111.623 136.361C112.241 136.398 112.84 136.594 113.361 136.931C113.881 137.267 114.307 137.732 114.595 138.281C114.883 138.83 115.025 139.444 115.007 140.063C114.989 140.683 114.811 141.287 114.491 141.818C114.17 142.349 113.719 142.788 113.179 143.093C112.639 143.398 112.03 143.559 111.41 143.56V143.56Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_30"
                        d="M122.229 35.3687H100.591V57.007H122.229V35.3687Z"
                        fill="#3F3D56"
                    />
                    <motion.path
                        id="Vector_31"
                        d="M111.41 38.9748C127.344 38.9748 140.261 34.4 140.261 28.7567C140.261 23.1134 127.344 18.5386 111.41 18.5386C95.4757 18.5386 82.5586 23.1134 82.5586 28.7567C82.5586 34.4 95.4757 38.9748 111.41 38.9748Z"
                        fill="#3F3D56"
                    />
                    <motion.path id="clock-arrow" d="M115 86H108V135H115V86Z" fill="#3F3D56" />
                    <motion.path
                        id="Vector_32"
                        d="M226 220.44H0V222.844H226V220.44Z"
                        fill="#3F3D56"
                    />
                    <motion.g id="plant-left">
                        <motion.path
                        id="Vector_33"
                        d="M150.594 599.754C151.527 631.704 132.858 643.413 109.43 644.097C108.886 644.113 108.344 644.123 107.805 644.126C106.719 644.135 105.643 644.117 104.577 644.072C83.3891 643.193 66.6172 631.945 65.7495 602.232C64.8515 571.482 103.018 531.529 105.882 528.574L105.887 528.571C105.996 528.458 106.052 528.402 106.052 528.402C106.052 528.402 149.661 567.807 150.594 599.754Z"
                        fill="#9e2a2b"
                        />
                        <motion.path
                        id="Vector_34"
                        d="M107.744 639.255L122.626 617.124L107.774 641.636L107.805 644.126C106.719 644.135 105.643 644.117 104.577 644.072L105.315 612.06L105.295 611.813L105.322 611.766L105.393 608.741L89.0952 585.078L105.374 606.477L105.432 607.116L105.989 582.93L91.9122 558.397L106.029 578.681L105.882 528.574L105.882 528.407L105.887 528.571L106.821 568.062L119.651 552.021L106.863 571.464L107.143 593.098L118.949 571.984L107.187 596.279L107.343 608.308L124.512 578.897L107.395 612.505L107.744 639.255Z"
                        fill="#3F3D56"
                        />
                    </motion.g>
                    <motion.g id="plant-right">
                        <motion.path
                        id="Vector_35"
                        d="M798.594 599.754C799.527 631.704 780.858 643.413 757.43 644.097C756.886 644.113 756.344 644.123 755.805 644.126C754.719 644.135 753.643 644.117 752.577 644.072C731.389 643.193 714.617 631.945 713.749 602.232C712.851 571.482 751.018 531.529 753.882 528.574L753.887 528.571C753.996 528.458 754.052 528.402 754.052 528.402C754.052 528.402 797.661 567.807 798.594 599.754Z"
                        fill="#fdc534"
                        />
                        <motion.path
                        id="Vector_36"
                        d="M755.744 639.255L770.626 617.124L755.774 641.636L755.805 644.126C754.719 644.135 753.643 644.117 752.577 644.072L753.315 612.06L753.295 611.813L753.323 611.766L753.393 608.741L737.095 585.078L753.374 606.477L753.432 607.116L753.989 582.93L739.912 558.397L754.029 578.681L753.882 528.574L753.882 528.407L753.887 528.571L754.821 568.062L767.651 552.021L754.864 571.464L755.143 593.098L766.949 571.984L755.187 596.279L755.343 608.308L772.512 578.897L755.395 612.505L755.744 639.255Z"
                        fill="#3F3D56"
                        />
                    </motion.g>
                    </motion.g>
                    <motion.defs>
                    <clipPath id="clip0">
                        <motion.rect width="798.627" height="689.223" fill="white" />
                    </clipPath>
                    </motion.defs>
                </motion.svg>
                <motion.img 
                    id="splash" 
                    src={splash} 
                    alt="" 
                    variants={fadeIn}
                />
            </IntroImg>
        </Intro>
    );
};

const Intro = styled(motion.div)`
    min-height: 90vh;
    width: 90%;
    margin: auto;
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;

    h2 {
        font-size: 7rem;
        padding-top: 2rem;
        color: #d36738;
        display: inline-block;
    }
    h3 {
        font-size: 6rem;
        padding: 2rem 0rem;
    }
    p {
        padding-top: 2rem;
        color: #2c2c2c;
    }
`;

const IntroText = styled(motion.div)`
    flex: 1 1 40rem;
    span{
        color: #44A4DA;
        font-weight: bolder;
    }

    @media screen and (max-width: 754px) {
        margin-top: 5rem;
        text-align: center;
    }
`;

const IntroSocial = styled(motion.div)`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    a {
        color: white;
    }
    button {
        cursor: pointer;
        margin-top: 3rem;
        margin-bottom: 3rem;
        width: 100%;
        padding: 3rem;
        background: #44A4DA;
        border-radius: 10px 100px / 120px;
        &:focus, &:hover {
            background: #d36738;
        }
    }

    @media screen and (max-width: 754px) {
        a {
            margin: 2rem;
        }
    }
`;

const IntroImg = styled(motion.div)`
    text-align: center;
    flex: 1 1 40rem;

    #splash{
        position: absolute;
        top: 0%;
        right: 0%;
        height: 100%;
        z-index: -1;
    }

    #plant-left {
        animation: plant 1.5s ease infinite alternate;
    }

    #plant-right {
        animation: plant 1.5s ease infinite alternate 0.5s;
    }

    #me, #shirt-thing {
        animation: me 2s ease-in-out infinite alternate;
        transform-origin: bottom;
    }

    #clock-arrow {
        animation: clock 1.5s infinite linear;
        transform-box: fill-box;
        transform-origin: bottom;
    }

    @keyframes plant {
        from {
            transform: translateY(0%);
        }
        to {
            transform: translateY(-20%);
        }
    }

    @keyframes me {
        from {
            transform: rotateZ(-5deg);
        }
        to {
            transform: rotateZ(5deg);
        }
    }

    @keyframes clock {
        from {
            transform: rotateZ(0deg);
        }
        to {
            transform: rotateZ(360deg);
        }
    }

    @media screen and (max-width: 1332px) {
        #splash {
            display: none;
        }
        svg {
            width: 80%;
        }
    }

    @media screen and (max-width: 754px) {
        svg {
            height: 60%;
        }
    }
`;

export default AboutSection;